import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { IDangerTooltip } from "./IDangerToolTip";
import { DangerToolTipContent } from "./DangerToolTipContent";

const theme = createMuiTheme({
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: "12px",
                color: "#d93923",
                backgroundColor: "#fce6d8",
                borderRadius: 0
            },
            popper: {
                marginTop: -13,
                borderRadius: 50
            }
        }
    }
});


export const DangerToolTip = (props: IDangerTooltip & { children: JSX.Element }) => {
    let content: IDangerTooltip = {
        previoustitle: props.previoustitle,
        previousnote: props.previousnote,
        previousdisclaimer: props.previousdisclaimer,
        previouscontent: props.previouscontent,
        currenttitle: props.currenttitle,
        currentnote: props.currentnote,
        currentdisclaimer: props.currentdisclaimer,
        currentcontent: props.currentcontent,
    }
    return (
        <MuiThemeProvider theme={createMuiTheme()}>
            <>
                <div>
                    <MuiThemeProvider theme={theme}>
                        <Tooltip title={DangerToolTipContent(content)} placement={'bottom-start'} >
                            <div>{props.children}</div>
                        </Tooltip>
                    </MuiThemeProvider>
                </div>
            </>
        </MuiThemeProvider>
    );
}
